import {userActionTypes} from "./actionTypes"

export function setMaritalStatus(status) {
    return {
        type: userActionTypes.SET_MARITAL_STATUS,
        payload: status
    }
}

export function setDependents(dependents) {
    return {
        type: userActionTypes.SET_DEPENDENTS,
        payload: dependents
    }
}

export function setDependentList(dependents) {
    return {
        type: userActionTypes.SET_DEPENDENT_LIST,
        payload: dependents
    }
}

export function setHealthPlanDetails(typicallyPayInfo, highDeductibleInfo) {
    return {
        type: userActionTypes.SET_HEALTH_PLAN_DETAILS,
        payload: {typicallyPayInfo, highDeductibleInfo}
    }
}

export function setLeftoverMoney(leftoverMoney) {
    return {
        type: userActionTypes.SET_LEFTOVER_MONEY,
        payload: leftoverMoney
    }
}

export function setLanguage(language) {
    return {
        type: userActionTypes.SET_LANGUAGE,
        payload: language
    }
}

export function setCoverageOption(opt, deleteChildren, deleteSpouse) {
    return {
        type: userActionTypes.SET_COVERAGE_OPTION,
        payload: {selectedCoverageOption: opt, deleteChildren, deleteSpouse }
    }
}

export function setCostPerOption(opt) {
    return {
        type: userActionTypes.SET_COST_PER_OPTION,
        payload: opt
    }
}

export function setModerateCoverage(opt) {
    return {
        type: userActionTypes.SET_MODERATE_COVERAGE,
        payload: opt
    }
}

export function setSevereCoverage(opt) {
    return {
        type: userActionTypes.SET_SEVERE_COVERAGE,
        payload: opt
    }
}

export function setCatastrophicCoverage(opt) {
    return {
        type: userActionTypes.SET_CATASTROPHIC_COVERAGE,
        payload: opt
    }
}

export function setPlanCoverageSelectedAndRecommended(moderate, moderateSelected, severe, severeSelected, catastrophic, catastrophicSelected) {
    return {
        type: userActionTypes.SET_SELECTED_AND_RECOMMENDED_COVERAGE,
        payload: {moderate, moderateSelected, severe, severeSelected, catastrophic, catastrophicSelected}
    }
}

export function setPlanCoverageSelectedAndRecommendedSelect(costValue, costEnhanced, costPremier, contribValue, contribEnhanced, contribPremier) {
    return {
        type: userActionTypes.SET_SELECT_COST,
        payload: {costValue, costEnhanced, costPremier, contribValue, contribEnhanced, contribPremier}
    }
}

export function setUserInfo(actionName, payload) {
    return {
        type: userActionTypes[actionName],
        payload: payload
    }
}

export function setBirthdate(payload) {
    return {
        type: userActionTypes.SET_BIRTHDATE,
        payload: payload
    }
}

export function setSsn(payload) {
    return {
        type: userActionTypes.SET_SSN,
        payload: payload
    }
}

export function setEnrollmentReceivedDate(payload) {
    return {
        type: userActionTypes.SET_ENROLLMENT_RECEIVED_DATE,
        payload: payload
    }
}

export function setPlanContribAndCost(contrib, cost) {
    return {
        type: userActionTypes.SET_PLAN_CONTRIB_COST,
        payload: {employerContribution: contrib, cost: cost}
    }
}

export function setBrellaSelectTierSelected(value, premier, enhanced) {
    return {
        type: userActionTypes.SET_BRELLA_SELECT_TIER_SELECTED,
        payload: {value, premier, enhanced}
    }
}

export function setDependent(dependent) {
    return {
        type: userActionTypes.SET_DEPENDENT,
        payload: {dependent}
    }
}

export function deleteDependent(id) {
    return {
        type: userActionTypes.DELETE_DEPENDENT,
        payload: {id}
    }
}

export function removeChild(idx) {
    return {
        type: userActionTypes.REMOVE_CHILD_IDX,
        payload: idx
    }
}

export function setValidEmployerPasscode() {
    return {
        type: userActionTypes.VALID_EMPLOYER_PASSCODE,
        payload: true
    }
}

export function setValidSsnVerification() {
    return {
        type: userActionTypes.VALID_SSN_VERIFICATION,
        payload: true
    }
}

export function resetUserData(){
    return {
        type: userActionTypes.RESET_USER_DATA,
        payload: {}
    }
}

export function setAllAddressFields(eeCensusAddress){
    return {
        type: userActionTypes.SET_ALL_ADDRESS_FIELDS,
        payload: eeCensusAddress
    }
}

export function setAccount(account){
    return {
        type: userActionTypes.SET_ACCOUNT,
        payload: account
    }
}

export function setGender(gender) {
    return {
        type: userActionTypes.SET_GENDER,
        payload: gender
    }
}

export function setFetchPlanRecommendation(fetchPlanRecommendation) {
    return {
        type: userActionTypes.SET_FETCH_PLAN_RECOMMENDATION,
        payload: {fetchPlanRecommendation}
    }
}

export function setResetTokenEmail(resetTokenEmail) {
    return {
        type: userActionTypes.SET_RESET_TOKEN_EMAIL,
        payload: {resetTokenEmail}
    }
}

export function setSkipRecommendation(recommendationSkipped) {
    return {
        type: userActionTypes.SET_SKIP_RECOMMENDATION,
        payload: {recommendationSkipped}
    }
}
